// catalog.proto — the canonical entities and read API over them.
//
// Everything here is post-resolution: a Work is one *thing in the world*
// stitched from however many upstream records describe it, not a row from any
// one site. The ExternalRef list is the audit trail for that stitching.

// @generated by protoc-gen-es v2.13.0 with parameter "target=ts,import_extension=none"
// @generated from file amrec/v1/catalog.proto (package amrec.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ContentRating, ExternalRef, FuzzyDate, MediaFormat, ReleaseStatus, Source, SourceStats, Title, WorkKind } from "./common_pb";
import { file_amrec_v1_common } from "./common_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file amrec/v1/catalog.proto.
 */
export const file_amrec_v1_catalog: GenFile = /*@__PURE__*/
  fileDesc("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", [file_amrec_v1_common, file_google_protobuf_timestamp]);

/**
 * Tag is a descriptive facet ("Time Loop", "Iyashikei", "Male Protagonist").
 * Genres and demographics are modelled as tags with a distinct `category` so
 * the recommender can weight a 90%-ranked "Psychological" tag differently from
 * the blunt "Drama" genre — that ranking is the single most useful signal
 * AniList exposes and a flat genre list throws it away.
 *
 * @generated from message amrec.v1.Tag
 */
export type Tag = Message<"amrec.v1.Tag"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * "genre" | "demographic" | "theme" | "content-warning"
   *
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * @generated from field: bool is_spoiler = 5;
   */
  isSpoiler: boolean;

  /**
   * @generated from field: bool is_adult = 6;
   */
  isAdult: boolean;
};

/**
 * Describes the message amrec.v1.Tag.
 * Use `create(TagSchema)` to create a new message.
 */
export const TagSchema: GenMessage<Tag> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 0);

/**
 * WorkTag is a tag applied to a work, carrying AniList's community rank
 * (0-100 = "how much is this work about this"). Sources without ranking write
 * rank=100 so downstream weighting has no special case.
 *
 * @generated from message amrec.v1.WorkTag
 */
export type WorkTag = Message<"amrec.v1.WorkTag"> & {
  /**
   * @generated from field: amrec.v1.Tag tag = 1;
   */
  tag?: Tag | undefined;

  /**
   * @generated from field: int32 rank = 2;
   */
  rank: number;
};

/**
 * Describes the message amrec.v1.WorkTag.
 * Use `create(WorkTagSchema)` to create a new message.
 */
export const WorkTagSchema: GenMessage<WorkTag> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 1);

/**
 * @generated from message amrec.v1.Relation
 */
export type Relation = Message<"amrec.v1.Relation"> & {
  /**
   * @generated from field: amrec.v1.RelationKind kind = 1;
   */
  kind: RelationKind;

  /**
   * @generated from field: string related_work_id = 2;
   */
  relatedWorkId: string;

  /**
   * Denormalized for list rendering so the UI doesn't N+1 the graph.
   *
   * @generated from field: string related_title = 3;
   */
  relatedTitle: string;

  /**
   * @generated from field: amrec.v1.WorkKind related_kind = 4;
   */
  relatedKind: WorkKind;
};

/**
 * Describes the message amrec.v1.Relation.
 * Use `create(RelationSchema)` to create a new message.
 */
export const RelationSchema: GenMessage<Relation> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 2);

/**
 * Image is a cover/banner reference. `proxy_path` is always populated and is
 * what clients must use — MangaDex actively blocks hotlinking and serves a
 * troll image to anyone who ignores that, so `source_url` is for provenance
 * and re-fetching only, never for an <img src>.
 *
 * @generated from message amrec.v1.Image
 */
export type Image = Message<"amrec.v1.Image"> & {
  /**
   * @generated from field: string source_url = 1;
   */
  sourceUrl: string;

  /**
   * e.g. "/covers/<sha256>" — see cover proxy
   *
   * @generated from field: string proxy_path = 2;
   */
  proxyPath: string;

  /**
   * @generated from field: int32 width = 3;
   */
  width: number;

  /**
   * @generated from field: int32 height = 4;
   */
  height: number;

  /**
   * 64-bit perceptual hash, hex. Used for near-duplicate detection and as a
   * tiebreaker during entity resolution.
   *
   * @generated from field: string phash = 5;
   */
  phash: string;
};

/**
 * Describes the message amrec.v1.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema: GenMessage<Image> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 3);

/**
 * @generated from message amrec.v1.Work
 */
export type Work = Message<"amrec.v1.Work"> & {
  /**
   * canonical UUID, ours not theirs
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: amrec.v1.WorkKind kind = 2;
   */
  kind: WorkKind;

  /**
   * @generated from field: amrec.v1.MediaFormat format = 3;
   */
  format: MediaFormat;

  /**
   * @generated from field: amrec.v1.ReleaseStatus status = 4;
   */
  status: ReleaseStatus;

  /**
   * @generated from field: amrec.v1.ContentRating content_rating = 5;
   */
  contentRating: ContentRating;

  /**
   * Display title, chosen by preference order at read time. The full set lives
   * in `titles` — search matches against all of them.
   *
   * @generated from field: string display_title = 6;
   */
  displayTitle: string;

  /**
   * @generated from field: repeated amrec.v1.Title titles = 7;
   */
  titles: Title[];

  /**
   * @generated from field: string synopsis = 8;
   */
  synopsis: string;

  /**
   * @generated from field: amrec.v1.FuzzyDate start_date = 9;
   */
  startDate?: FuzzyDate | undefined;

  /**
   * @generated from field: amrec.v1.FuzzyDate end_date = 10;
   */
  endDate?: FuzzyDate | undefined;

  /**
   * Counts are kind-dependent and frequently unknown upstream (0 = unknown).
   *
   * @generated from field: int32 episode_count = 11;
   */
  episodeCount: number;

  /**
   * @generated from field: int32 chapter_count = 12;
   */
  chapterCount: number;

  /**
   * @generated from field: int32 volume_count = 13;
   */
  volumeCount: number;

  /**
   * per episode
   *
   * @generated from field: int32 duration_minutes = 14;
   */
  durationMinutes: number;

  /**
   * @generated from field: amrec.v1.Image cover = 15;
   */
  cover?: Image | undefined;

  /**
   * @generated from field: amrec.v1.Image banner = 16;
   */
  banner?: Image | undefined;

  /**
   * @generated from field: repeated amrec.v1.WorkTag tags = 17;
   */
  tags: WorkTag[];

  /**
   * @generated from field: repeated amrec.v1.Relation relations = 18;
   */
  relations: Relation[];

  /**
   * @generated from field: repeated amrec.v1.ExternalRef sources = 19;
   */
  sources: ExternalRef[];

  /**
   * @generated from field: repeated amrec.v1.SourceStats stats = 20;
   */
  stats: SourceStats[];

  /**
   * Studios (anime), publishers/serializations (manga), developers (VN).
   *
   * @generated from field: repeated amrec.v1.Organization organizations = 21;
   */
  organizations: Organization[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 22;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 23;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message amrec.v1.Work.
 * Use `create(WorkSchema)` to create a new message.
 */
export const WorkSchema: GenMessage<Work> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 4);

/**
 * Organization covers studios, publishers, and VN developers — the same shape
 * with a role discriminator, because a single company is routinely all three
 * (Kadokawa publishes, produces, and develops) and splitting them into three
 * tables would duplicate the entity and break "more from this company".
 *
 * @generated from message amrec.v1.Organization
 */
export type Organization = Message<"amrec.v1.Organization"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * "studio" | "producer" | "publisher" | "developer"
   *
   * @generated from field: string role = 3;
   */
  role: string;

  /**
   * @generated from field: bool is_main = 4;
   */
  isMain: boolean;

  /**
   * @generated from field: repeated amrec.v1.ExternalRef sources = 5;
   */
  sources: ExternalRef[];
};

/**
 * Describes the message amrec.v1.Organization.
 * Use `create(OrganizationSchema)` to create a new message.
 */
export const OrganizationSchema: GenMessage<Organization> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 5);

/**
 * Person is a real human: author, artist, director, voice actor, composer.
 *
 * @generated from message amrec.v1.Person
 */
export type Person = Message<"amrec.v1.Person"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * preferred romanized
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string native_name = 3;
   */
  nativeName: string;

  /**
   * @generated from field: repeated string aliases = 4;
   */
  aliases: string[];

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: amrec.v1.Image portrait = 6;
   */
  portrait?: Image | undefined;

  /**
   * @generated from field: repeated amrec.v1.ExternalRef sources = 7;
   */
  sources: ExternalRef[];
};

/**
 * Describes the message amrec.v1.Person.
 * Use `create(PersonSchema)` to create a new message.
 */
export const PersonSchema: GenMessage<Person> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 6);

/**
 * Credit links a Person to a Work in a role. Voice-acting credits also carry
 * the character, which is what makes "same VA" queries possible.
 *
 * @generated from message amrec.v1.Credit
 */
export type Credit = Message<"amrec.v1.Credit"> & {
  /**
   * @generated from field: amrec.v1.Person person = 1;
   */
  person?: Person | undefined;

  /**
   * "Story", "Art", "Director", "Voice", ...
   *
   * @generated from field: string role = 2;
   */
  role: string;

  /**
   * set for voice roles
   *
   * @generated from field: string character_id = 3;
   */
  characterId: string;

  /**
   * for voice roles: "Japanese", "English", ...
   *
   * @generated from field: string language = 4;
   */
  language: string;
};

/**
 * Describes the message amrec.v1.Credit.
 * Use `create(CreditSchema)` to create a new message.
 */
export const CreditSchema: GenMessage<Credit> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 7);

/**
 * @generated from message amrec.v1.Character
 */
export type Character = Message<"amrec.v1.Character"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string native_name = 3;
   */
  nativeName: string;

  /**
   * @generated from field: repeated string aliases = 4;
   */
  aliases: string[];

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: amrec.v1.Image portrait = 6;
   */
  portrait?: Image | undefined;

  /**
   * @generated from field: repeated amrec.v1.ExternalRef sources = 7;
   */
  sources: ExternalRef[];
};

/**
 * Describes the message amrec.v1.Character.
 * Use `create(CharacterSchema)` to create a new message.
 */
export const CharacterSchema: GenMessage<Character> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 8);

/**
 * CharacterAppearance is a character in one work, with billing.
 *
 * @generated from message amrec.v1.CharacterAppearance
 */
export type CharacterAppearance = Message<"amrec.v1.CharacterAppearance"> & {
  /**
   * @generated from field: amrec.v1.Character character = 1;
   */
  character?: Character | undefined;

  /**
   * "MAIN" | "SUPPORTING" | "BACKGROUND"
   *
   * @generated from field: string role = 2;
   */
  role: string;

  /**
   * @generated from field: repeated amrec.v1.Credit voice_actors = 3;
   */
  voiceActors: Credit[];
};

/**
 * Describes the message amrec.v1.CharacterAppearance.
 * Use `create(CharacterAppearanceSchema)` to create a new message.
 */
export const CharacterAppearanceSchema: GenMessage<CharacterAppearance> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 9);

/**
 * @generated from message amrec.v1.GetWorkRequest
 */
export type GetWorkRequest = Message<"amrec.v1.GetWorkRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Relations, characters and credits are each an extra join; list views don't
   * need them. Opt in rather than always paying for the full object.
   *
   * @generated from field: bool include_relations = 2;
   */
  includeRelations: boolean;

  /**
   * @generated from field: bool include_characters = 3;
   */
  includeCharacters: boolean;

  /**
   * @generated from field: bool include_credits = 4;
   */
  includeCredits: boolean;
};

/**
 * Describes the message amrec.v1.GetWorkRequest.
 * Use `create(GetWorkRequestSchema)` to create a new message.
 */
export const GetWorkRequestSchema: GenMessage<GetWorkRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 10);

/**
 * @generated from message amrec.v1.GetWorkResponse
 */
export type GetWorkResponse = Message<"amrec.v1.GetWorkResponse"> & {
  /**
   * @generated from field: amrec.v1.Work work = 1;
   */
  work?: Work | undefined;

  /**
   * @generated from field: repeated amrec.v1.CharacterAppearance characters = 2;
   */
  characters: CharacterAppearance[];

  /**
   * @generated from field: repeated amrec.v1.Credit credits = 3;
   */
  credits: Credit[];
};

/**
 * Describes the message amrec.v1.GetWorkResponse.
 * Use `create(GetWorkResponseSchema)` to create a new message.
 */
export const GetWorkResponseSchema: GenMessage<GetWorkResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 11);

/**
 * LookupWorkRequest resolves an upstream ID to our canonical work. This is the
 * integration seam for "I have a MAL link, show me your page" and for the
 * list importer.
 *
 * @generated from message amrec.v1.LookupWorkRequest
 */
export type LookupWorkRequest = Message<"amrec.v1.LookupWorkRequest"> & {
  /**
   * @generated from field: amrec.v1.Source source = 1;
   */
  source: Source;

  /**
   * @generated from field: string source_id = 2;
   */
  sourceId: string;
};

/**
 * Describes the message amrec.v1.LookupWorkRequest.
 * Use `create(LookupWorkRequestSchema)` to create a new message.
 */
export const LookupWorkRequestSchema: GenMessage<LookupWorkRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 12);

/**
 * @generated from message amrec.v1.LookupWorkResponse
 */
export type LookupWorkResponse = Message<"amrec.v1.LookupWorkResponse"> & {
  /**
   * unset if we've never seen it
   *
   * @generated from field: amrec.v1.Work work = 1;
   */
  work?: Work | undefined;
};

/**
 * Describes the message amrec.v1.LookupWorkResponse.
 * Use `create(LookupWorkResponseSchema)` to create a new message.
 */
export const LookupWorkResponseSchema: GenMessage<LookupWorkResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 13);

/**
 * @generated from message amrec.v1.ListWorksRequest
 */
export type ListWorksRequest = Message<"amrec.v1.ListWorksRequest"> & {
  /**
   * @generated from field: repeated amrec.v1.WorkKind kinds = 1;
   */
  kinds: WorkKind[];

  /**
   * @generated from field: repeated amrec.v1.MediaFormat formats = 2;
   */
  formats: MediaFormat[];

  /**
   * @generated from field: repeated amrec.v1.ReleaseStatus statuses = 3;
   */
  statuses: ReleaseStatus[];

  /**
   * Inclusive ceiling. Defaults to SAFE when unset — NSFW is stored but never
   * returned unless a caller explicitly raises this.
   *
   * @generated from field: amrec.v1.ContentRating max_rating = 4;
   */
  maxRating: ContentRating;

  /**
   * @generated from field: repeated string tag_ids = 5;
   */
  tagIds: string[];

  /**
   * @generated from field: int32 year_from = 6;
   */
  yearFrom: number;

  /**
   * @generated from field: int32 year_to = 7;
   */
  yearTo: number;

  /**
   * "popularity" | "score" | "recent"
   *
   * @generated from field: string order_by = 8;
   */
  orderBy: string;

  /**
   * @generated from field: int32 page_size = 9;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 10;
   */
  pageToken: string;
};

/**
 * Describes the message amrec.v1.ListWorksRequest.
 * Use `create(ListWorksRequestSchema)` to create a new message.
 */
export const ListWorksRequestSchema: GenMessage<ListWorksRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 14);

/**
 * @generated from message amrec.v1.ListWorksResponse
 */
export type ListWorksResponse = Message<"amrec.v1.ListWorksResponse"> & {
  /**
   * @generated from field: repeated amrec.v1.Work works = 1;
   */
  works: Work[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_estimate = 3;
   */
  totalEstimate: number;
};

/**
 * Describes the message amrec.v1.ListWorksResponse.
 * Use `create(ListWorksResponseSchema)` to create a new message.
 */
export const ListWorksResponseSchema: GenMessage<ListWorksResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 15);

/**
 * @generated from message amrec.v1.GetCharacterRequest
 */
export type GetCharacterRequest = Message<"amrec.v1.GetCharacterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message amrec.v1.GetCharacterRequest.
 * Use `create(GetCharacterRequestSchema)` to create a new message.
 */
export const GetCharacterRequestSchema: GenMessage<GetCharacterRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 16);

/**
 * @generated from message amrec.v1.GetCharacterResponse
 */
export type GetCharacterResponse = Message<"amrec.v1.GetCharacterResponse"> & {
  /**
   * @generated from field: amrec.v1.Character character = 1;
   */
  character?: Character | undefined;

  /**
   * Works this character appears in, most prominent first.
   *
   * @generated from field: repeated amrec.v1.Work appearances = 2;
   */
  appearances: Work[];

  /**
   * @generated from field: repeated amrec.v1.Credit voice_actors = 3;
   */
  voiceActors: Credit[];
};

/**
 * Describes the message amrec.v1.GetCharacterResponse.
 * Use `create(GetCharacterResponseSchema)` to create a new message.
 */
export const GetCharacterResponseSchema: GenMessage<GetCharacterResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 17);

/**
 * @generated from message amrec.v1.GetPersonRequest
 */
export type GetPersonRequest = Message<"amrec.v1.GetPersonRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message amrec.v1.GetPersonRequest.
 * Use `create(GetPersonRequestSchema)` to create a new message.
 */
export const GetPersonRequestSchema: GenMessage<GetPersonRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 18);

/**
 * @generated from message amrec.v1.GetPersonResponse
 */
export type GetPersonResponse = Message<"amrec.v1.GetPersonResponse"> & {
  /**
   * @generated from field: amrec.v1.Person person = 1;
   */
  person?: Person | undefined;

  /**
   * @generated from field: repeated amrec.v1.Credit credits = 2;
   */
  credits: Credit[];
};

/**
 * Describes the message amrec.v1.GetPersonResponse.
 * Use `create(GetPersonResponseSchema)` to create a new message.
 */
export const GetPersonResponseSchema: GenMessage<GetPersonResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_catalog, 19);

/**
 * RelationKind is the edge type in the work relation graph. Adaptation edges
 * are what let a manga recommendation surface its anime and vice versa, so the
 * graph is queried across kinds, never within one.
 *
 * @generated from enum amrec.v1.RelationKind
 */
export enum RelationKind {
  /**
   * @generated from enum value: RELATION_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RELATION_KIND_SEQUEL = 1;
   */
  SEQUEL = 1,

  /**
   * @generated from enum value: RELATION_KIND_PREQUEL = 2;
   */
  PREQUEL = 2,

  /**
   * @generated from enum value: RELATION_KIND_ADAPTATION = 3;
   */
  ADAPTATION = 3,

  /**
   * @generated from enum value: RELATION_KIND_SOURCE = 4;
   */
  SOURCE = 4,

  /**
   * @generated from enum value: RELATION_KIND_SIDE_STORY = 5;
   */
  SIDE_STORY = 5,

  /**
   * @generated from enum value: RELATION_KIND_PARENT = 6;
   */
  PARENT = 6,

  /**
   * @generated from enum value: RELATION_KIND_ALTERNATIVE = 7;
   */
  ALTERNATIVE = 7,

  /**
   * @generated from enum value: RELATION_KIND_SPIN_OFF = 8;
   */
  SPIN_OFF = 8,

  /**
   * @generated from enum value: RELATION_KIND_CHARACTER = 9;
   */
  CHARACTER = 9,

  /**
   * @generated from enum value: RELATION_KIND_SUMMARY = 10;
   */
  SUMMARY = 10,

  /**
   * @generated from enum value: RELATION_KIND_OTHER = 11;
   */
  OTHER = 11,
}

/**
 * Describes the enum amrec.v1.RelationKind.
 */
export const RelationKindSchema: GenEnum<RelationKind> = /*@__PURE__*/
  enumDesc(file_amrec_v1_catalog, 0);

/**
 * @generated from service amrec.v1.CatalogService
 */
export const CatalogService: GenService<{
  /**
   * @generated from rpc amrec.v1.CatalogService.GetWork
   */
  getWork: {
    methodKind: "unary";
    input: typeof GetWorkRequestSchema;
    output: typeof GetWorkResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.CatalogService.LookupWork
   */
  lookupWork: {
    methodKind: "unary";
    input: typeof LookupWorkRequestSchema;
    output: typeof LookupWorkResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.CatalogService.ListWorks
   */
  listWorks: {
    methodKind: "unary";
    input: typeof ListWorksRequestSchema;
    output: typeof ListWorksResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.CatalogService.GetCharacter
   */
  getCharacter: {
    methodKind: "unary";
    input: typeof GetCharacterRequestSchema;
    output: typeof GetCharacterResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.CatalogService.GetPerson
   */
  getPerson: {
    methodKind: "unary";
    input: typeof GetPersonRequestSchema;
    output: typeof GetPersonResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_amrec_v1_catalog, 0);

